<template>
  <oops v-if="showOops" :row-type="rowType"/>
  <item-page v-else
    :show-progress="showProgress"
    :item-reason="itemReason"
    :row-type="rowType"
    :item="item"
    :content-heading="contentHeading"
    :item-obj="itemReason"
    :item-name="itemName"
    :row-types="rowTypes"
    :auth="auth"
  />
</template>
<script>
import Itempage from '@/components/Itempage'
import { PersonPage, Controls } from '@/gql'
import { mergeControls } from '@/js/apollo'
import { SearchUtils } from '@/js'
import oops from '@/components/Oops'
export default {
  components: {
    'item-page': Itempage,
    oops
  },
  props: {
    auth: Object
  },
  watch: {
    Controls(val) {
      if (val.refresh) {
        this.$apollo.queries.PersonPage.refetch()
        mergeControls ({
          refresh: false
        })
      }
    }
  },
  data: () => ({
    rowTypes: ['award', 'film', 'company']
  }),
  computed: {
    showOops() {
      return !this.itemMake && !this.$apollo.loading;
    },
    contentHeading () {
      return 'Person details'
    },
    itemName () {
      return 'Person'
    },
    rowType () {
      return 'person'
    },
    passedItem () {
      return this.params.item
    },
    showProgress () {
      return this.itemMake && !this.itemMake.big
    },
    item () {
      return this.itemMake && this.itemMake.item
    },
    itemMake () {
      // make the award query look like a reason from the summary page
      // but if we are coming from a awardpage, we'll already have some of what we need
      // so use that to start building thepage while the query is still in progress
      let item = SearchUtils.makeSearcherFromPerson(this.PersonPage)
      if (item) {
        return {
          item,
          big: true
        }
      }
      if (!this.passedItem) {
        return null
      }
      // we got one, so make it look like it was the result of a search
      item = this.passedItem
      if (this.rowType !== item.itemType) {
        console.log(`expected ${this.rowType} but got item ${item.itemType}`)
      }
      return {
        item
      }
    },
    params () {
      return this.$route.params
    },
    id () {
      return this.params.id
    },
    itemReason () {
      return this.item && this.item.itemReason
    }
  },
  apollo: {
    Controls: {
      query: Controls
    },
    PersonPage: {
      query: PersonPage,
      variables () {
        return {
          id: this.id
        }
      }
    }
  }
}
</script>
